import React from 'react';
import { Hero } from '../components/Hero';
import { OpeningHook } from '../components/OpeningHook';
import { Problem } from '../components/Problem';
import { FailedMethods } from '../components/FailedMethods';
import { UniqueMechanism } from '../components/UniqueMechanism';
import { WhatYouGet } from '../components/WhatYouGet';
import { WhoIsFor } from '../components/WhoIsFor';
import { HowItWorks } from '../components/HowItWorks';
import { Proof } from '../components/Proof';
import { FAQ } from '../components/FAQ';
import { PriceBlock } from '../components/PriceBlock';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-cream selection:bg-periwinkle/30" data-id="element-170">
      <Hero data-id="element-171" />
      <OpeningHook data-id="element-172" />
      <Problem data-id="element-173" />
      <FailedMethods data-id="element-174" />
      <UniqueMechanism data-id="element-175" />
      <WhatYouGet data-id="element-176" />
      <WhoIsFor data-id="element-177" />
      <HowItWorks data-id="element-178" />
      <Proof data-id="element-179" />
      <FAQ data-id="element-180" />
      <PriceBlock data-id="element-181" />
      <FinalCTA data-id="element-182" />
      <Footer data-id="element-183" />
    </main>;
}